import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=7173a30f"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"
import style0 from "./TextContent.vue?vue&type=style&index=0&id=7173a30f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7173a30f')) {
      api.createRecord('7173a30f', component.options)
    } else {
      api.reload('7173a30f', component.options)
    }
    module.hot.accept("./TextContent.vue?vue&type=template&id=7173a30f", function () {
      api.rerender('7173a30f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/TextContent.vue"
export default component.exports